<div class="pd">
    <form
    [formGroup]="changePasswordForm"
    (ngSubmit)="submitChangedPassword()"
    >

    <input
        type="text"
        name="username"
        autocomplete="username"
        [value]="''"
        hidden
    />

    <nz-form-item>
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
       
        <nz-form-control>
            <input
            placeholder="{{'PROFILE.CHANGE_PASSWORD.CURRENT_PASSWORD' | translate}}"
            nz-input
            class="v2-input"
            name="old_password"
            type="password"
            id="old_password"
            formControlName="old_password"
            autocomplete="current-password"
            />
        </nz-form-control>
        </nz-col>
    </nz-form-item>

    <nz-form-item>
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
        
        <nz-form-control [nzErrorTip]="errorT">
            <input
            nz-input
            class="v2-input"
            placeholder="{{'GENERAL.NEW_PASSWORD_PLACEHOLDER' | translate}}"
            name="password"
            type="password"
            id="password"
            formControlName="password"
            autocomplete="new-password"
            />
        </nz-form-control>
        <ng-template #errorT let-control>
            <ng-container>{{'PROFILE.CHANGE_PASSWORD.MINIMUM_LENGTH' | translate}}</ng-container>
        </ng-template>
        </nz-col>
    </nz-form-item>


    <nz-form-item>
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="24" [nzXl]="24">
        
        <nz-form-control [nzErrorTip]="errorTpl">
            <input
            nz-input
            class="v2-input"
            placeholder="{{'PROFILE.CHANGE_PASSWORD.PASSWORD_CONFIRMATION' | translate}}"
            name="password_confirmation"
            type="password"
            id="password_confirmation"
            formControlName="password_confirmation"
            autocomplete="password confirmation"
            />

            <ng-template #errorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
                >{{'PROFILE.CHANGE_PASSWORD.PLEASE_CONFIRM' | translate}}</ng-container
            >
            <ng-container *ngIf="control.hasError('confirm')">
                {{'PROFILE.CHANGE_PASSWORD.PASSWORD_MISMATCH' | translate}}
            </ng-container>
            </ng-template>
        </nz-form-control>
        </nz-col>
    </nz-form-item>

    <nz-form-item nz-row class="register-area">
        <nz-form-control
        [nzSm]="24"
        [nzXs]="24"
        [nzMd]="8"
        [nzLg]="6"
        [nzXl]="4"
        >
        <button
            nz-button
            [nzType]="'primary'"
            class="v2-btn-primary"
            [nzLoading]="loading"
            [disabled]="!changePasswordForm.valid"
            nzBlock
        >
            {{'GENERAL.SUBMIT' | translate | uppercase}}
        </button>
        </nz-form-control>
    </nz-form-item>
    </form>
</div>
